export default __webpack_public_path__ + "static/media/menuIcons.95869518.svg";